import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { collection, getDocs, query } from "firebase/firestore";
import db from "../../firebase";
import styles from "./MyAccount.module.css";
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import cld from "../../cloudinary";
import { AdvancedImage } from "@cloudinary/react";

const RecievedSection = () => {
  const loggedUser = useSelector((state) => state.loggedUser);
  const [bids, setBids] = useState();

  useEffect(() => {
    const getBids = async () =>
      await getDocs(
        query(collection(db, `user_data/${loggedUser.uid}/images`))
      ).then((bidsData) => {
        const data = bidsData.docs.map((bidData) => bidData.data());
        setBids(data.length > 0 ? data : null);
      });
    getBids();
  }, []);

  return bids && bids.length > 0 ? (
    <div className="d-flex">
      {bids.map((item, index) => (
        <div className={styles.singleCart} key={index}>
          <AdvancedImage
            cldImg={cld
              .image(item.image)
              .resize(thumbnail(300, 400).gravity("faces"))}
            className={styles.singleCartImg}
          />
        </div>
      ))}
    </div>
  ) : bids === null ? (
    <div className="text-center text-white py-4">No Recieved Found!</div>
  ) : (
    <div className="text-center py-4">
      <div className="spinner-border text-light" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default RecievedSection;
